import axios from '../utils/axios';

export default function fetchFollowUpCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/company-follow-up-count', { params })
    )
}